import { Box, Card, Skeleton } from '@mui/material';
import { profileCardSX, skeletonColor } from '../profileStyles';

export const ProfileSignatureCardSkeleton = () => {
  return (
    <Card elevation={0} sx={{ ...profileCardSX, gridColumn: { xs: '1', md: '1 / -1' }, padding: 2.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, marginBottom: 2 }}>
        <Skeleton
          variant="rounded"
          width={32}
          height={32}
          sx={{ backgroundColor: skeletonColor, borderRadius: '9px' }}
        />
        <Box>
          <Skeleton variant="text" width={140} height={20} sx={{ backgroundColor: skeletonColor }} />
          <Skeleton variant="text" width={220} height={16} sx={{ backgroundColor: skeletonColor }} />
        </Box>
      </Box>
      <Skeleton
        variant="rounded"
        width="100%"
        height={40}
        sx={{ backgroundColor: skeletonColor, borderRadius: '8px' }}
      />
    </Card>
  );
};
